import { AnfrageDisplayModel, GlobalEnumerationsAceTypphase } from "@/api/model-index";
import { AnfrageService } from "@/api/services/anfrage.service";
import { AnfrageContract } from "@/core/models/abstractions/anfrage.contract";
import { AnfrageTransformerService } from "@/core/services/anfrage-transformer.service";
import { I18nService } from "@/core/services/i18nService";
import { PortalContextService } from "@/core/services/portal-context.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { NotificationService } from "@progress/kendo-angular-notification";
import { map } from "rxjs/internal/operators/map";

@Injectable({
    providedIn: 'root'
})
export class AnfrageGuard  {
    protected instance: AnfrageContract | null;

    constructor(protected readonly router: Router, protected readonly portalContextService: PortalContextService, protected readonly anfrageService: AnfrageService, protected notificationService: NotificationService, protected langService: I18nService, protected anfrageTransformService: AnfrageTransformerService) {
        //
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const skipAnfrageGuard: boolean | null = this.router.currentNavigation()?.extras?.state?.skipAnfrageGuard;
        if (skipAnfrageGuard === true) {
            return Promise.resolve(true);
        }

        await this.getAnfrage(route, state);


        if (!this.portalContextService.CurrentAnfrage?.phase?.typ || this.portalContextService.CurrentAnfrage?.phase?.typ == GlobalEnumerationsAceTypphase.Standard) {
            let url: string = state.url;
            let urlParts: string[] = url.split("/");

            if (urlParts[2] == "detail") {
                if (!urlParts[5] && !urlParts[6])
                    return Promise.resolve(true);
                if (this.portalContextService.CurrentAnfrage.phase?.abschnitte?.find(x => x.id == urlParts[6])
                    || this.portalContextService.CurrentAnfrage.phase?.abschnitte?.flatMap(x => x.abschnitte).find(x => x && x.id == urlParts[6]))
                    return Promise.resolve(true);
                if (urlParts[5] == "dataprotection" && !urlParts[6])
                    return Promise.resolve(true);
            }
        }
        this.notificationService.show({
            hideAfter: 5000,
            content: this.langService.instant("anfrage.anfrage-guard.error"),
            animation: { type: "fade", duration: 500 },
            position: { horizontal: "center", vertical: "bottom" },
            type: { style: "error", icon: true },
        });

        this.router.navigate(['/anfrage/overview']);
        return Promise.resolve(false);
    }

    async getAnfrage(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<AnfrageDisplayModel | undefined> {
        if (this.portalContextService.CurrentAnfrage && this.portalContextService.isTempAnfrageId(this.portalContextService.CurrentAnfrage.id)) {
            // The CurrentAnfrage was set from the ausschreibung-card and its a temp anfrage, so we just use that and dont fetch it because it does not exist yet
            return this.portalContextService.CurrentAnfrage;
        }

        return await this.anfrageService.apiAnfrageAnfrageIdGet({ anfrageId: this.portalContextService.CurrentItemContext.id }).pipe(map(async response => {
            if (response) {
                this.portalContextService.CurrentAnfrage = await this.anfrageTransformService.transform(response);

                if (this.portalContextService.CurrentAnfrage)
                    return this.portalContextService.CurrentAnfrage;
            }

            return undefined;
        })).toPromise();
    }
}